import { Box, styled } from "@mui/material";

const askNovaAnchorStyles = {
  position: "fixed" as const,
  bottom: 24,
  right: 24,
  zIndex: 1100,
};

export const AskNovaLauncher = styled(Box)(({ theme }) => ({
  ...askNovaAnchorStyles,
  boxShadow: theme.shadows[4],
  borderRadius: theme.shape.borderRadius,
}));

export const AskNovaChatContainer = styled(Box)(({ theme }) => ({
  ...askNovaAnchorStyles,
  width: "calc(100vw - 32px)",
  height: "calc(100vh - 48px)",
  maxHeight: "calc(100vh - 48px)",
  overflow: "hidden",
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  backgroundColor: "var(--modus-wc-color-white)",
  [theme.breakpoints.up("sm")]: {
    width: 400,
    height: 640,
  },
}));
